import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { SearchProvider } from "./context/SearchContext";
import RouteSeo from "./components/RouteSeo";
import LocalBusinessJsonLd from "./components/LocalBusinessJsonLd";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import CataloguePage from "./pages/CataloguePage";
import RealisationsPage from "./pages/RealisationsPage";
import FAQPage from "./pages/FAQPage";
import BlogPage from "./pages/BlogPage";
import BlogArticlePage from "./pages/BlogArticlePage";
import AProposPage from "./pages/AProposPage";
import DevisPage from "./pages/DevisPage";
import AdminPage from "./pages/AdminPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import ConfidentialitePage from "./pages/ConfidentialitePage";
import CGLPage from "./pages/CGLPage";
import LocationPage from "./pages/LocationPage";
import GuideTechniquePage from "./pages/GuideTechniquePage";
import ProductPage from "./pages/ProductPage";
import NotFoundPage from "./pages/NotFoundPage";
import PromoDisplay from "./components/PromoDisplay";

function ScrollToTop() {
  var location = useLocation();
  React.useEffect(function() { window.scrollTo(0, 0); }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <SearchProvider>
            <ScrollToTop />
            <RouteSeo />
            <LocalBusinessJsonLd />
            <PromoDisplay />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/catalogue" element={<CataloguePage />} />
                <Route path="/catalogue/:category" element={<CataloguePage />} />
                <Route path="/catalogue/:category/:subcategory" element={<CataloguePage />} />
                <Route path="/realisations" element={<RealisationsPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogArticlePage />} />
                <Route path="/a-propos" element={<AProposPage />} />
                <Route path="/devis" element={<DevisPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/location/:slug" element={<LocationPage />} />
                <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
                <Route path="/confidentialite" element={<ConfidentialitePage />} />
                <Route path="/conditions-generales-location" element={<CGLPage />} />
                {/* URLs existantes à conserver pour SEO */}
                <Route path="/galerie" element={<RealisationsPage />} />
                <Route path="/conseils-evenementiels" element={<BlogPage />} />
                <Route path="/services" element={<CataloguePage />} />
                <Route path="/catalogue/:category/:subcategory/:slug" element={<ProductPage />} />
                <Route path="/guide-technique" element={<GuideTechniquePage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <Footer />
          </SearchProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
